module.exports = __webpack_public_path__ + "static/river-1-14f56f2ccdc8adda235edc5e213158fb.jpg";